export const PIPELINE_NETWORK_GOOGLE_ANALYTICS_TAG = 'PIPELINE_NETWORK';
